var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12908_51500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.93018 11C7.93018 7.96211 10.5561 5.5 13.7962 5.5C17.0362 5.5 19.6622 7.96211 19.6622 11C19.6622 14.0379 17.0362 16.5 13.7962 16.5C10.5561 16.5 7.93018 14.0379 7.93018 11ZM13.7962 14.4375C15.8218 14.4375 17.4625 12.8992 17.4625 11C17.4625 9.10078 15.8218 7.5625 13.7962 7.5625C13.7641 7.5625 13.7366 7.5625 13.6633 7.5625C13.7641 7.78164 13.7962 8.01367 13.7962 8.25C13.7962 9.7668 12.4809 11 10.8632 11C10.6111 11 10.3637 10.9699 10.1299 10.8754C10.1299 10.9441 10.1299 10.9699 10.1299 10.9613C10.1299 12.8992 11.7706 14.4375 13.7962 14.4375ZM4.97059 4.83828C7.12818 2.95797 10.0933 1.375 13.7962 1.375C17.4991 1.375 20.4642 2.95797 22.6227 4.83828C24.7675 6.70312 26.2019 8.89883 26.8801 10.4715C27.0314 10.8109 27.0314 11.1891 26.8801 11.5285C26.2019 13.0625 24.7675 15.2582 22.6227 17.1617C20.4642 19.0437 17.4991 20.625 13.7962 20.625C10.0933 20.625 7.12818 19.0437 4.97059 17.1617C2.82583 15.2582 1.39232 13.0625 0.710445 11.5285C0.56006 11.1891 0.56006 10.8109 0.710445 10.4715C1.39232 8.89883 2.82583 6.70312 4.97059 4.83828ZM13.7962 3.4375C10.8082 3.4375 8.3518 4.70937 6.46826 6.34648C4.70387 7.88477 3.48576 9.67227 2.86341 11C3.48576 12.2891 4.70387 14.1152 6.46826 15.6535C8.3518 17.2906 10.8082 18.5625 13.7962 18.5625C16.7842 18.5625 19.2406 17.2906 21.1241 15.6535C22.8885 14.1152 24.0663 12.2891 24.7308 11C24.0663 9.67227 22.8885 7.88477 21.1241 6.34648C19.2406 4.70937 16.7842 3.4375 13.7962 3.4375Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12908_51500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3971,
    height: 22,
    fill: "white",
    transform: "translate(0.597656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.26939243e5fa7381d744c0e925a01f38.svg";
export { ForwardRef as ReactComponent };